const TOKEN = 'f3tc.access.token'
const TOKEN_EXPIRES_AT = 'f3tc.token.expires-at'
const OAUTH_STATE = 'f3tc.oauth.state'
const OAUTH_NONCE = 'f3tc.oauth.nonce'

class LocalStorageUtils {
  saveSession(token: string, expiresInSeconds: number) {
    localStorage.setItem(TOKEN, token)
    localStorage.setItem(TOKEN_EXPIRES_AT, String(Date.now() + expiresInSeconds * 1000))
  }

  clearSession() {
    localStorage.removeItem(TOKEN)
    localStorage.removeItem(TOKEN_EXPIRES_AT)
  }

  getToken() {
    return localStorage.getItem(TOKEN)
  }

  getTokenExpiresAt() {
    const value = localStorage.getItem(TOKEN_EXPIRES_AT)
    return value ? Number(value) : null
  }

  isTokenValid() {
    const token = this.getToken()
    const expiresAt = this.getTokenExpiresAt()
    return Boolean(token && expiresAt && Date.now() < expiresAt)
  }

  saveOAuthState(state: string) {
    localStorage.setItem(OAUTH_STATE, state)
  }

  getOAuthState() {
    return localStorage.getItem(OAUTH_STATE)
  }

  removeOAuthState() {
    localStorage.removeItem(OAUTH_STATE)
  }

  saveOAuthNonce(nonce: string) {
    localStorage.setItem(OAUTH_NONCE, nonce)
  }

  getOAuthNonce() {
    return localStorage.getItem(OAUTH_NONCE)
  }

  removeOAuthNonce() {
    localStorage.removeItem(OAUTH_NONCE)
  }
}

export default new LocalStorageUtils()
